module.exports = __webpack_public_path__ + "static/img/book-6.358b55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book-6.png
// module id = KZoU
// module chunks = 10